import { Injectable } from "@angular/core";
import { Http, Response, URLSearchParams } from "@angular/http";
import {
    IAOTSCOrg,
    IAOTSCOrgs,
    ITCIApplicationDeployResponse,
    ITCIApplicationTenancyRequest,
    ITCIApplicationTenancyResponse,
    ITCIEnvVars,
    SERVICE_URLS
} from "@tci/common";
import { Observable } from "rxjs";
import { NgEnvVarsService } from "../../ng-shared/ng-services/ng-env-vars.service";

@Injectable()
export class BaseAppHMCopyService {

    constructor(private http: Http, private envVarsService: NgEnvVarsService) {

    }
    /**
     * Get organizations the user belongings
     */
    getOrganizations(): Observable<IAOTSCOrg[]> {
        return this.http.get(`${SERVICE_URLS.TENANCY_ORGS}`)
            .map((response: Response) =>  response.json());
    }

    getOrganizationsV2(page: number, limit: number): Observable<IAOTSCOrgs> {
        return this.http.get(`${SERVICE_URLS.TENANCY_ORGS_V2}?page=${page.toString()}&limit=${limit.toString()}`)
            .map((response: Response) =>  response.json());
    }

    getEnvVar(envName: string): Observable<ITCIEnvVars<any>> {
        return this.envVarsService.getEnvVar(envName);
    }

    /**
     * Copy application to org
     * @param reqParam
     */
    copyApp(reqParam: ITCIApplicationTenancyRequest): Observable<ITCIApplicationTenancyResponse> {
        return Observable.create( observer => {
            this.http.post(SERVICE_URLS.TENANCY, reqParam).subscribe(
                succRsp => {
                    observer.next(succRsp.json());
                }, errRsp => {
                    observer.error(errRsp.json());
                }
            );
        });

        // return this.http.post(SERVICE_URLS.TENANCY, reqParam)
        //     .map((response: Response) => response.json() );
    }

    getAppRuningStatus(appId: string, desiredInstance: number): Observable<ITCIApplicationDeployResponse> {
        const queryParams = new URLSearchParams();
        queryParams.append("desiredInstanceCount", desiredInstance.toString());
        return this.http.get(`${SERVICE_URLS.TENANCY_STATUS}/${appId}`, {search: queryParams})
            .map((rsp: Response) =>  rsp.json());
    }

}
